import BackOfficeHeader from "components/commons/BackofficeHeader";
import React from "react";

const Header = () => {
  return <BackOfficeHeader title={"Solicitudes de certificados"} />;
};

export default Header;
